export default {"src":"__ASTRO_ASSET_IMAGE__e4ITTRGy__","width":48,"height":48,"format":"png"}